<template>
  <div>
    <v-container fluid class="px-6 py-6">
      <v-row class="mt-8">
        <v-col cols="12">
          <div>
            <v-card class="card-shadow border-radius-xl">
              <div class="card-header-padding">
                <div class="d-flex align-center justify-space-between">
                  <div>
                    <h5 class="font-weight-bold text-h5 text-typo mb-0">
                      Document transaction - {{ urlParams.document_name }}
                    </h5>
                    <p class="text-sm text-body mb-0">
                      Allowed transactions of selected document
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="back"
                    elevation="0"
                    :ripple="false"
                    height="43"
                    dark
                    class="
                      font-weight-bold
                      text-capitalize
                      ms-auto
                      btn-primary
                      bg-success
                      py-3
                      px-6
                      ms-3
                      ma-2
                    "
                    >Back</v-btn
                  >
                  <v-dialog v-model="dialog" max-width="1000px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        elevation="0"
                        dark
                        :ripple="false"
                        height="43"
                        class="
                          font-weight-bold
                          text-capitalize
                          ms-auto
                          btn-primary
                          bg-success
                          py-3
                          px-6
                          ms-3
                        "
                        >New document transaction</v-btn
                      >
                    </template>
                    <v-card class="card-shadow border-radius-xl">
                      <div class="card-header-padding card-border-bottom">
                        <span class="font-weight-bold text-h5 text-typo mb-0">{{
                          formTitle
                        }}</span>
                      </div>
                      <v-card-text class="card-padding">
                        <v-container class="px-0">
                          <v-form ref="frm">
                            <v-row>
                              <v-col cols="3">
                                <label
                                  class="
                                    text-md text-typo
                                    font-weight-bolder
                                    ms-1
                                  "
                                  >Document State</label
                                >
                                <v-select
                                  v-model="editedItem.current_state"
                                  :items="documentState"
                                  item-text="master_state"
                                  return-object
                                  color="rgba(0,0,0,.6)"
                                  class="
                                    input-style
                                    font-size-input
                                    text-light-input
                                    placeholder-light
                                    border-radius-md
                                    select-style
                                    mt-3
                                    mb-0
                                  "
                                  placeholder="Select a State"
                                  :rules="[(v) => !!v || 'State is Required']"
                                  outlined
                                  single-line
                                  height="46"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="3">
                                <label
                                  class="
                                    text-md text-typo
                                    font-weight-bolder
                                    ms-1
                                  "
                                  >Action</label
                                >
                                <v-select
                                  v-model="editedItem.action"
                                  :items="documentAction"
                                  item-text="master_action"
                                  return-object
                                  color="rgba(0,0,0,.6)"
                                  class="
                                    input-style
                                    font-size-input
                                    text-light-input
                                    placeholder-light
                                    border-radius-md
                                    select-style
                                    mt-3
                                    mb-0
                                  "
                                  placeholder="Select a Action"
                                  :rules="[(v) => !!v || 'Action is Required']"
                                  outlined
                                  single-line
                                  height="46"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="3">
                                <label
                                  class="
                                    text-md text-typo
                                    font-weight-bolder
                                    ms-1
                                  "
                                  >Next State</label
                                >
                                <v-select
                                  v-model="editedItem.next_state"
                                  :items="documentState"
                                  item-text="master_state"
                                  return-object
                                  color="rgba(0,0,0,.6)"
                                  class="
                                    input-style
                                    font-size-input
                                    text-light-input
                                    placeholder-light
                                    border-radius-md
                                    select-style
                                    mt-3
                                    mb-0
                                  "
                                  placeholder="Select a Next state"
                                  :rules="[
                                    (v) => !!v || 'Next state is Required',
                                  ]"
                                  outlined
                                  single-line
                                  height="46"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="3">
                                <label
                                  class="
                                    text-md text-typo
                                    font-weight-bolder
                                    ms-1
                                    mandatory
                                  "
                                  ><span class="red--text"
                                    ><strong></strong
                                  ></span>
                                  Role</label
                                >
                                <v-select
                                  v-model="editedItem.role"
                                  :items="role"
                                  item-text="role"
                                  return-object
                                  color="rgba(0,0,0,.6)"
                                  class="
                                    input-style
                                    font-size-input
                                    text-light-input
                                    placeholder-light
                                    border-radius-md
                                    select-style
                                    mt-3
                                    mb-0
                                  "
                                  placeholder="Select a Role"
                                  :rules="[(v) => !!v || 'Role is Required']"
                                  outlined
                                  single-line
                                  height="46"
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions class="card-padding d-flex justify-end">
                        <v-btn
                          @click="close"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          class="
                            font-weight-bold
                            text-capitalize
                            btn-ls btn-secondary
                            bg-gradient-light
                            py-3
                            px-6
                          "
                          >Cancel</v-btn
                        >

                        <v-btn
                          @click="save"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          dark
                          class="
                            text-capitalize
                            btn-ls btn-primary
                            bg-success
                            py-3
                            px-6
                          "
                          >Save</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>

              <v-card-text class="px-0 py-0">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  class="table"
                  :page.sync="page"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  :items-per-page="itemsPerPage"
                  mobile-breakpoint="0"
                >
                  <template v-slot:top>
                    <v-toolbar flat height="80">
                      <v-row>
                        <v-col cols="12" md="5">
                          <v-text-field
                            hide-details
                            class="
                              input-style
                              font-size-input
                              text-light-input
                              placeholder-light
                              input-icon
                            "
                            dense
                            flat
                            filled
                            solo
                            height="43"
                            v-model="search"
                            placeholder="Search"
                          >
                            <template slot="prepend-inner">
                              <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-spacer></v-spacer>

                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card
                          class="card-shadow card-padding border-radius-xl"
                        >
                          <v-card-title
                            class="pt-0 text-h5 text-typo justify-center"
                            >Are you sure you want to delete this
                            item?</v-card-title
                          >
                          <v-card-actions class="pb-0">
                            <v-spacer></v-spacer>
                            <v-btn
                              @click="closeDelete"
                              elevation="0"
                              :ripple="false"
                              height="43"
                              class="
                                font-weight-bold
                                text-capitalize
                                btn-ls
                                bg-gradient-light
                                py-3
                                px-6
                              "
                              >Cancel</v-btn
                            >

                            <v-btn
                              @click="deleteItemConfirm"
                              elevation="0"
                              :ripple="false"
                              height="43"
                              class="
                                font-weight-bold
                                text-capitalize
                                btn-ls btn-primary
                                bg-success
                                py-3
                                px-6
                              "
                              >Ok</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <!-- [`item.actions`]="{ item }" -->
                  <template v-slot:[`item.actions`]="{ item }">
                    <!-- <v-btn
                      @click="editItem(item)"
                      icon
                      elevation="0"
                      :ripple="false"
                      height="28"
                      min-width="36"
                      width="36"
                      class=""
                      color="green"
                      >Edit
                    </v-btn> -->

                    <v-btn
                      @click="deleteItem(item)"
                      icon
                      elevation="0"
                      :ripple="false"
                      height="28"
                      min-width="36"
                      width="36"
                      class="ml-5"
                      color="#FF0000"
                    >
                      delete
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="card-padding">
                <v-row>
                  <v-col cols="6" lg="4" class="d-flex align-center">
                    <span class="text-body me-3 text-sm">Items per page:</span>
                    <v-select
                      hide-details
                      :items="paginationLimits"
                      item-text="label"
                      item-value="id"
                      outlined
                      background-color="rgba(255,255,255,.9)"
                      color="rgba(0,0,0,.6)"
                      light
                      v-model="itemsPerPage"
                      placeholder="Items per page"
                      class="
                        font-size-input
                        placeholder-lighter
                        text-color-light
                        input-alternative input-focused-alternative input-icon
                      "
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6" class="ml-auto d-flex justify-end">
                    <v-pagination
                      prev-icon="fa fa-angle-left"
                      next-icon="fa fa-angle-right"
                      class="pagination"
                      color="#38bd34"
                      v-model="page"
                      :length="pageCount"
                      circle
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- :input_data="[{ Transaction_name: '', Transaction_code: '' }]" -->
  </div>
</template>
<script>
import api from "../api";
import { paginationLimits } from "../../../../global-data/paginationLimits";

export default {
  name: "Transaction",
  data() {
    return {
      urlParams: null,
      page: 1,
      pageCount: 0,
      paginationLimits: paginationLimits,
      itemsPerPage: 10,

      dialog: false,
      dialogDelete: false,
      items: [],
      search: "",
      editedIndex: -1,
      documentState: [],
      documentAction: [],
      role: [],
      editedItem: {
        current_state: null,
        next_state: null,
        action: null,
        document: null,
        role: null,
      },
      defaultItem: {
        current_state: null,
        next_state: null,
        action: null,
        document: null,
        role: null,
      },
      headers: [
        {
          text: "Current state",
          align: "start",
          sortable: true,
          value: "current_state.master_state",
        },
        {
          text: "Action",
          align: "start",
          sortable: true,
          value: "action.master_action",
        },
        {
          text: "Next state",
          align: "start",
          sortable: true,
          value: "next_state.master_state",
        },
        {
          text: "Role",
          align: "start",
          sortable: true,
          value: "role.role",
        },

        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  created() {
    this.initialize();
  },
  methods: {
    validate() {
      return this.$refs.frm.validate();
    },
    reset() {
      return this.$refs.frm.reset();
    },

    back() {
      this.$router.push({ name: "Document" });
    },

    showSuccessAlert(message) {
      this.$swal({
        title: "Success",
        text: message,
        type: "success",
        timer: 3000,
        icon: "success",
        showConfirmButton: false,
      });
    },

    showErrorAlert(message) {
      this.$swal({
        title: "Error",
        text: message,
        type: "error",
        icon: "error",
        showConfirmButton: true,
      });
    },
    async initialize() {
      this.urlParams = this.$route.query;
      this.editedItem.document = this.$route.query;
      this.items = await api.getTransactionByDocumentId(this.urlParams.id);

      this.documentState = await api.getMasterState();
      this.documentAction = await api.getMasterAction();
      this.role = await api.getRole();
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await api.deleteTransaction(this.editedItem.id);
      this.items.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.reset();
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.editedItem.document = this.$route.query;
      if (this.validate()) {
        try {
          let type = "Saved";
          if (this.editedIndex > -1) {
            type = "Updated";
            await api.editTransaction(this.editedItem.id, this.editedItem);
            Object.assign(this.items[this.editedIndex], this.editedItem);
          } else {
            await api.createTransaction(this.editedItem);
          }
          this.showSuccessAlert(`Transaction ${type}.`);
          this.initialize();
          this.reset();
        } catch (err) {
          this.showErrorAlert(err.message);
        }
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Transaction" : "Edit Transaction";
    },
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
        : 0;
    },
  },
};
</script>
